import React, { useEffect, useState } from "react";
import { ResponsiveContainer, AreaChart, Area, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import { IndianRupee, TrendingUp, CheckCircle2, XCircle } from "lucide-react";
import api from "@/lib/api";
import PageHeader from "@/components/common/PageHeader";
import StatCard from "@/components/common/StatCard";
import ChartCard, { chartTooltipStyle } from "@/components/common/ChartCard";
import { CardSkeletonGrid } from "@/components/common/Loading";

export default function Revenue() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/revenue").then(({ data }) => setData(data)); }, []);
  if (!data) return <div className="space-y-6"><PageHeader title="Revenue" /><CardSkeletonGrid /></div>;

  return (
    <div className="space-y-6">
      <PageHeader title="Revenue" subtitle="Monthly recurring revenue and collections" icon={TrendingUp} />
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        <StatCard label="MRR" value={`₹${data.mrr.toLocaleString()}`} icon={IndianRupee} accent="green" />
        <StatCard label="ARR" value={`₹${data.arr.toLocaleString()}`} icon={TrendingUp} accent="brand" />
        <StatCard label="Paid Clients" value={data.paid} icon={CheckCircle2} accent="green" />
        <StatCard label="Unpaid Clients" value={data.unpaid} icon={XCircle} accent="red" />
      </div>
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
        <ChartCard title="Revenue Trend" subtitle="Last 6 months">
          <ResponsiveContainer width="100%" height={280}>
            <AreaChart data={data.chart}>
              <defs><linearGradient id="r2" x1="0" y1="0" x2="0" y2="1"><stop offset="5%" stopColor="#291d89" stopOpacity={0.3} /><stop offset="95%" stopColor="#291d89" stopOpacity={0} /></linearGradient></defs>
              <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
              <XAxis dataKey="label" tick={{ fontSize: 12, fill: "#94a3b8" }} axisLine={false} tickLine={false} />
              <YAxis tick={{ fontSize: 12, fill: "#94a3b8" }} axisLine={false} tickLine={false} />
              <Tooltip {...chartTooltipStyle()} />
              <Area type="monotone" dataKey="revenue" stroke="#291d89" strokeWidth={2.5} fill="url(#r2)" />
            </AreaChart>
          </ResponsiveContainer>
        </ChartCard>
        <ChartCard title="Revenue by Plan">
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={data.byPlan}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
              <XAxis dataKey="name" tick={{ fontSize: 12, fill: "#94a3b8" }} axisLine={false} tickLine={false} />
              <YAxis tick={{ fontSize: 12, fill: "#94a3b8" }} axisLine={false} tickLine={false} />
              <Tooltip {...chartTooltipStyle()} />
              <Bar dataKey="revenue" fill="#4e67eb" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </ChartCard>
      </div>
    </div>
  );
}
